module.exports = __webpack_public_path__ + "static/img/asiana-cs-competition.bdb5130.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/asiana-cs-competition.jpg
// module id = zJSm
// module chunks = 0